import React, { Fragment } from 'react';
import SearchBox from '../../../../../../components/outline/SearchBox';
import BaseForm from '../../../../../../components/form/BaseForm';
import Select from '../../../../../../components/input/Select/Select';
import TextArea from '../../../../../../components/input/TextArea/TextArea';
import CheckBox from '../../../../../../components/input/CheckBox';
import ButtonList from '../../../../../../components/ButtonList';
import DateRangePicker from '../../../../../../components/datePicker/DateRangePicker';
import { DATE_FORMAT, QUICK_DATE_SELECT_BUTTON_TARGET } from '../../../../../../constants/service/common/utilConstants';
import {
  MAXIMUM_NUMBER_OF_ORDER_DETAIL_SEARCH_WORD,
  ORDER_CANCEL_ITEM_DETAIL_SEARCH_TYPE_SELECT_LIST,
  ORDER_SEARCH_PERIOD_BUTTON_LIST,
  SEARCH_ORDER_CANCEL_STATUS_CHECK_BOX_LIST,
  SEARCH_ORDER_MANAGER_CHECK_BOX_LIST,
} from '../../../../../../constants/service/app/orderConstants';
import { PRODUCT_MANAGEMENT_TYPE_SELECT_LIST } from '../../../../../../constants/service/app/productConstants';
import { BRAND_SEARCH_TYPE_SELECT_LIST } from '../../../../../../constants/service/app/brandConstants';
import { setClearDash, setIfNull, setQuickToDate, setTrim } from '../../../../../../lib/common';
import './OrderCancelManagementListSearchBox.scss';

const OrderCancelManagementListSearchBox = (props) => {
  const { setData, searchData, onSearch, onClear } = props;
  const {
    canceledDate,
    orderCancelStatusList,
    cancelAcceptManagerList,
    cancelManagerList,
    orderItemDetailSearch,
    productType,
    store,
  } = searchData;

  return (
    <SearchBox
      className="order-cancel-management-list-search-box"
      onSearch={() => onSearch()}
      onClear={() => onClear()}
    >
      {/*취소 요청 일시*/}
      <BaseForm
        label="취소 요청 일시"
        content={
          <div className="quick-date-picker">
            {/*날짜 선택 빠른 키*/}
            <ButtonList
              current={canceledDate.quickDateIndex}
              list={ORDER_SEARCH_PERIOD_BUTTON_LIST}
              onClick={(data) =>
                setData({
                  path: ['canceledDate'],
                  value: setQuickToDate({
                    id: data.id,
                    value: data.value,
                    target: QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE,
                    period: canceledDate.period,
                  }),
                })
              }
            />

            {/*날짜 선택*/}
            <DateRangePicker
              value={canceledDate.period}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(period) =>
                setData({
                  path: ['canceledDate'],
                  value: setQuickToDate({
                    period,
                  }),
                })
              }
            />
          </div>
        }
      />

      {/*취소 상태*/}
      <BaseForm
        label="취소 상태"
        content={
          <Fragment>
            {SEARCH_ORDER_CANCEL_STATUS_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={orderCancelStatusList.includes(item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['orderCancelStatusList'],
                    value: checked
                      ? orderCancelStatusList.concat(item.id)
                      : orderCancelStatusList.filter((id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      {/*취소 접수자*/}
      <BaseForm
        label="취소 접수자"
        content={
          <Fragment>
            {SEARCH_ORDER_MANAGER_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={cancelAcceptManagerList.includes(item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['cancelAcceptManagerList'],
                    value: checked
                      ? cancelAcceptManagerList.concat(item.id)
                      : cancelAcceptManagerList.filter((id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      {/*취소 처리자*/}
      <BaseForm
        label="취소 처리자"
        content={
          <Fragment>
            {SEARCH_ORDER_MANAGER_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={cancelManagerList.includes(item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['cancelManagerList'],
                    value: checked
                      ? cancelManagerList.concat(item.id)
                      : cancelManagerList.filter((id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      <BaseForm
        label="상세 검색"
        content={
          <Fragment>
            <Select
              list={ORDER_CANCEL_ITEM_DETAIL_SEARCH_TYPE_SELECT_LIST}
              onChange={(id) =>
                setData({
                  path: ['orderItemDetailSearch', 'type'],
                  value: id,
                })
              }
              value={orderItemDetailSearch.type}
              isTable={true}
            />

            <TextArea
              value={orderItemDetailSearch.value}
              maxLength={MAXIMUM_NUMBER_OF_ORDER_DETAIL_SEARCH_WORD}
              placeholder={`상품 ID, 주문번호, 상품 주문번호, 브랜드 ID를 검색하는 경우 ","구분자를 이용하여 여러 주문 건을 검색할 수 있습니다. `}
              onChange={(value) => {
                setData({
                  path: ['orderItemDetailSearch', 'value'],
                  value: setIfNull(setTrim(setClearDash(value))),
                });
              }}
              onPressEnter={() => onSearch()}
            />
          </Fragment>
        }
      />

      <BaseForm
        label="상품 타입"
        content={
          <Fragment>
            {PRODUCT_MANAGEMENT_TYPE_SELECT_LIST.map((item) => (
              <CheckBox
                key={item.id}
                value={item.id}
                text={item.name}
                checked={productType.includes(item.id)}
                onChange={(checked) =>
                  setData({
                    path: ['productType'],
                    value: checked ? [...productType, item.id] : productType.filter((id) => item.id !== id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      <BaseForm
        label="관리처"
        content={
          <Fragment>
            {BRAND_SEARCH_TYPE_SELECT_LIST.map((item) => (
              <CheckBox
                key={item.id}
                value={item.id}
                text={item.name}
                checked={store.includes(item.id)}
                onChange={(checked) =>
                  setData({
                    path: ['store'],
                    value: checked ? [...store, item.id] : store.filter((id) => item.id !== id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />
    </SearchBox>
  );
};

export default OrderCancelManagementListSearchBox;
